const api="https://api.555mix.com/api"; //production

// const api="http://188.166.206.155:8080/api"; // development
export default api;